import React, { useEffect, useRef, useState } from "react";
import UploadCoverArt from './../../../images/uploadcoverart.png'
import PlayTrackIcon from './../../../images/playtrackicon.png'
import PauseIcon from './../../../images/pauseicon.png'


import JpProTag from './../../../images/jp-protag.png'
import UploadTrackBox from './../../../images/uploadtrackbox.png'
import MoreTrackInfo from './../../../images/moretrackdetails.png'
import Disclaimericon from './../../../images/disclaimericon.png'
import RequestSubmittedIcon from './../../../images/requestsubmittedicon.png'
import crossicon from './../../../images/crossicon.png'
import DisclaimerPopup from './../../../images/settingsdisclaimericon.png'
import ArrowDown from './../../../images/arrowdown.png'
import royaltyIcon from './../../../images/rolaytyicon.png'
import ReleaseMusicImg from './../../../images/release-music-img.png'
import ProTag from './../../../images/protag.png'
import N3rveLogo from './../../../images/N3rveLogo.png'

import CrossIcon from './../../../images/crossicon.png'
import EnIcon from "./../../../images/englishicon.png"
import JapIcon from "./../../../images/japanicon.png"
import DashNavbarCross from './../../../images/dashnavbarcross.png'
import NavbarDesc from "./../../../images/navbar_desc.png"
import axios from 'axios' 
import Cookies from "universal-cookie";

import ReactModal from 'react-modal';
import { AlertTitle } from "@mui/material";
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import { useForm } from "react-hook-form";
import {useLocation,useNavigate} from "react-router-dom";
import DatePicker from "react-datepicker";
import CryptoJS from 'crypto-js';
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"
import { useJwt, decodeToken } from "react-jwt";
import AudioButton from "./../../PostLogin/Dashboard/ReleaseMusic/AudioBtn";
import { Switch } from '@mui/base/Switch';
import { styled } from '@mui/system';
import { useSwitch } from '@mui/base/useSwitch';
import clsx from 'clsx';
import {Route,Routes, Redirect, Navigate} from 'react-router-dom'
import UploadFiles from "./../../PostLogin/Dashboard/ReleaseMusic/UploadFiles";
import AlbumPhoto from "./../../PostLogin/Dashboard/ReleaseMusic/AlbumPhoto";
import AlbumDetails from "./../../PostLogin/Dashboard/ReleaseMusic/AlbumDetails";
import TrackDetails from "./../../PostLogin/Dashboard/ReleaseMusic/TrackDetails";
import RoyaltySplit from "./../../PostLogin/Dashboard/ReleaseMusic/RoyaltySplit";
import ReleaseDate from "./../../PostLogin/Dashboard/ReleaseMusic/ReleaseDate";
import AlbumSummary from "./../../PostLogin/Dashboard/ReleaseMusic/AlbumSummary";
 
// import ReactLanguageSelect from 'react-languages-select';D_StarthoverOverTrack

// import 'react-languages-select/css/react-languages-select.css';
var switchChecked =false
var primaryChecked =false
var featured1Checked =false
var featured2Checked =false
var featured3Checked =false
var featured4Checked =false
var featured5Checked =false
var featured6Checked =false

function ReleaseMusic({func,nav,hidedashboard,sharedData,prevInfo,prevPage,shareData}) {

  //Functional Variables
  const navigate = useNavigate();
  const inputRef = useRef(null)
  const addRef = useRef(null)
  const ref = useRef(null)
  var ChunkCount = 0

  const cookies = new Cookies(null ,{ path: '/' });
  const {t, i18n } = useTranslation();
  const [dimensions, setDimensions] = useState({height: window.innerHeight,width: window.innerWidth});
  const { register, handleSubmit } = useForm();
  const location = useLocation();

  
  const [pagePath,setPagePath] = useState()

  //Upload File variables
  const [files,setFiles] = useState([])
  const [audiolength,setAudioLength] = useState([])
  const [audioplay,setAudioPlay] = useState([])
  const [trackUploaded,setTrackUploaded] = useState(false)

  //Album Art variables
  const [albumImage,setAlbumImage] = useState([])
  const [albumImageError,setAlbumImageError] = useState(false)

  //Album Details variables
  const [releaseTitle,setReleaseTitle] = useState("")
  const [artistName,setArtistname] = useState("")
  const [genre,setGenre] = useState("")
  const [distributeAs,setDistribute] = useState("")
  const [format,setFormat] = useState("")
  const [switchChecked,setSwitchChecked] = useState(false)
  const [formatcontainerclass,setFormatContainerClass] = useState("FormatDetailsModule")
  const [totalVolumes,setTotalVolumes] = useState(1)
  const [explicitAlbumContent,setExplicitAlbumContent] = useState({ value: false, label: 'No' })
  const [defaultdatecontainerclass,setDefaultDateContainerClass] =   useState("DefaultDateDetailsModule")
  const [consumerReleaseDate,setConsumerReleaseDate] = useState("")
  const [consumerReleaseTime,setConsumerReleaseTime] = useState("")
  const [preorderDate,setPreorderDate] = useState("")
  const [releasedatecontainerclass,setReleaseDateContainerClass] =   useState("ReleaseDateDetailsModule")
  const [originalReleaseDate,setOriginalReleaseDate] = useState("")
  const [recordingYear,setRecordingYear] = useState("")
  const [recordingLocation,setRecordingLocation] = useState("")
  const [disclaimer,setDisclaimer] = useState(false)
  const [cCopyrightYear,setCCopyrightYear] = useState("")
  const [cCopyrightText,setCCopyrightTexy] = useState("")
  const [pCopyrightYear,setPCopyrightYear] = useState("")
  const [pCopyrightText,setPCopyrightTexy] = useState("")
  const [albumLanguage,setAlbumLanguage] = useState("")
  const [genrecontainerclass,setGenreContainerClass] = useState("GenreDetailsModule")
  const [subgenre,setSubGenre] = useState("")
  const [alternategenre,setAlternateGenre] = useState("")
  const [alternateSubgenre,setAlternateSubGenre] = useState("")


   //Track Details variables
   const [artistId,setArtistId] = useState();
   const [Trackname,setTrackname] = useState("");
   const [newArtistName,setnewArtistName] = useState("");
   const [newArtistISNI,setnewArtistISNI] = useState("");
   const [addArtistDisclaimer,setAddArtistDisclaimer] = useState(false);
   const [advanceTrackFields,setAdvanceTrackFields] = useState(false);
   const [tracklanguageclass,setTrackLanguageClass] = useState("TrackLanguageModule")
   const [lyricsclass,setLyricsClass] = useState("LyricsModule")
   const [role,setRole] = useState("")
   const [trackartist,setTrackArtist] = useState("")
   const [artistRoles,setArtistRoles] = useState([])
   const [instrument,setInstruments] = useState("")
   const [artistInstuments,setArtistInstruments] = useState([])
   const [roleToggle,setRoleToggle] = useState(false)
   const [artistToggle,setArtistToggle] = useState(false)
   const [instrumentToggle,setInstumentToggle] = useState(false)
   const [publishers,setPublisher] = useState("")
   const [composer,setComposer] = useState("")
   const [lyrics,setLyrics] = useState("")
   const [trackartists,setTrackArtists] = useState([])
   const [trackartistsIds,setTrackArtistsIds] = useState([])
   const [trackContributors,setTrackContributors] = useState([])
   const [trackContributorsIds,setTrackContributorsIds] = useState([])
   const [trackPublishers,setTrackPublishers] = useState([])
   const [trackPublishersIds,setTrackPublishersIds] = useState([])

   const [contributor,setContributor] = useState("")
   const [producer1,setProducer1] = useState("")
   const [viewProducer2,setViewProducer2] = useState(false)
   const [viewProducer3,setViewProducer3] = useState(false)
   const [producer2,setProducer2] = useState("")
   const [producer3,setProducer3] = useState("")
   const [songwriter1,setSongwriter1] = useState("")
   const [viewSongwriter2,setViewSongwriter2] = useState(false)
   const [viewSongwriter3,setViewSongwriter3] = useState(false)
   const [songwriter2,setSongwriter2] = useState("")
   const [songwriter3,setSongwriter3] = useState("")
   const [featuredArtist1,setFeaturedArtist1] = useState("")
   const [viewFeaturedArtist2,setViewFeaturedArtist2] = useState(false)
   const [viewFeaturedArtist3,setViewFeaturedArtist3] = useState(false)
   const [featuredArtist2,setFeaturedArtist2] = useState("")
   const [featuredArtist3,setFeaturedArtist3] = useState("")
   const [trackMetadatLanguage,setTrackMetadataLanguage] = useState("")
   const [explicitContent,setExplicitContent] = useState("")
   const [Price,setPrice] = useState(0)
   const [AudioLanguage,setAudioLanguage] = useState("")
   const [RadioEdit,setRadioEdit] = useState(false)
   const [songwriter1Id,setSongwriter1Id] = useState(0)
   const [songwriter2Id,setSongwriter2Id] = useState(0)
   const [songwriter3Id,setSongwriter3Id] = useState(0)
   const [producer1Id,setProducer1Id] = useState(0)
   const [producer2Id,setProducer2Id] = useState(0)
   const [producer3Id,setProducer3Id] = useState(0)
   const [featuredArtist1Id,setfeaturedArtistId1] = useState(0)
   const [featuredArtist2Id,setfeaturedArtistId2] = useState(0)
   const [featuredArtist3Id,setfeaturedArtistId3] = useState(0)
   const [unsavedChanges,setUnsavedChanges] = useState(false)

   const [songwriter1Error,setSongwriter1Error] = useState(false)
   const [songwriter2Error,setSongwriter2Error] = useState(false)
   const [songwriter3Error,setSongwriter3Error] = useState(false)
   const [producer1Error,setProducer1Error] = useState(false)
   const [producer2Error,setProducer2Error] = useState(false)
   const [producer3Error,setProducer3Error] = useState(false)
   const [featuredArtist1Error,setFeaturedArtist1Error] = useState(false)
   const [featuredArtist2Error,setFeaturedArtist2Error] = useState(false)
   const [featuredArtist3Error,setFeaturedArtist3Error] = useState(false)


   //Royalty Split variables
   const [collaboratorArray,setcollaboratorArray] = useState([100,0])
   const [collaborator1Email,setcollaborator1Email] = useState("")
   const [collaborator1,setCollaborator1] = useState(false)
   const [collaborator2Email,setcollaborator2Email] = useState("")
   const [collaborator2,setCollaborator2] = useState(false)
   const [collaborator3Email,setcollaborator3Email] = useState("")
   const [collaborator3,setCollaborator3] = useState(false)
   const [collaboratorError,setCollaboratorError] = useState(false)
   const [collaboratorPercentError,setCollaboratorPercentError] = useState(false)
   const [checkCollaboratorArr,setCheckCollaboratorArr] = useState(0)
   const [royaltynextBtn,setRoyaltyNextBtn] = useState(false)
   

   //Release date variables
   const [releaseDate,setReleaseDate] = useState("")
   const [releaseDateUpload,setReleaseDateUpload] = useState("")
   const [isChecked1, setIsChecked1] = useState(false);
   const [isChecked2, setIsChecked2] = useState(false);
   const [dragActive , setDragActive] = useState(false)

   const [loading , setLoading] = useState(false);

   const [localUploadCount,setLocalUploadCount] = useState(0)

  //Popup variables
  const [LogoutPopup,setLogoutPopup] = useState(false)

  
  const [exitAction,setExitAction] = useState("")


  // Drag Area Variables

  const [ImageDragActive , setImageDragActive] = useState(false)


  const [toggleDashBoard,setToggleDashboard] = useState(false)
  const [languagedropdown,setLanguageDropdown] = useState(false)
  const [language,setLanguage] = useState()
   
   const [productId,setProductId] = useState()
   const [coverImageId,setCoverImageId] = useState()
   const [assetId,setAssetId] = useState([])
   const [labelId,setLabelId] = useState(5355516108)
   const [pageno,setPageNo] = useState(0)
   
   
   const [hoverTrack,setHoverTrack] = useState(false)
   

   


   const [offset,setOffset] = useState(0)

   const [refreshAsset,setRefreshAsset] = useState(1)
 

   
   const [uploadChunkCount,setUploadChunkCount] = useState(0)

   const [artistLabel,setArtistLabel] = useState("")

   const [md5,setMd5] = useState("")
   const [filename,setFilename] = useState("")
   const [uuid,setUUid] = useState("")

   const [popupId,setPopupId] = useState(0)
   const [contributorId,setContributorId] = useState(0)
   const [publisherId,setPublisherId] = useState(0)
   const [CollaboratorId,setCollaboratorId] = useState(0)

   const [imageuploadcomplete,setImageUploadComplete] = useState(false)
   const [imageuploadError,setImageuploadError] = useState(false)


   const [releaseTitleError,setReleaseTitleError] = useState(false)
   const [genreError,setGenreError] = useState(false)
   const [distributeError, setDistibuteError] = useState(false)
   const [formatError,setFormatError]  = useState(false)
   const [trackPopup,setTrackPopup] = useState(false)
   const [saveProgressPopup,setSaveProgressPopup] = useState(false)
   const [deletePopup,setDeletePopup] = useState(false)
   const [editContributorPopup,setEditContibutorPopup] = useState(false)
   const [editPublisherPopup,setEditPublisherPopup] = useState(false)
   const [deleteTrackIndex,setDeleteTrackIndex] = useState(false)
   const [unsavedChangesPopup,setUnsavedChangesPopup] = useState(false)
   const [createArtistPopup,setCreateArtistPopup] = useState(false)
   const [addContributorPopup,setAddContributorPopup] = useState(false)
   const [addPublisherPopup,setAddPublisherPopup] = useState(false)
   const [releaseDateError,setReleaseDateError] = useState(1)
   const [toggleFormatDetails,setToggleFormatDetails] = useState(false)
  


   const [checkAssetArr,setCheckAssetArr] = useState(0)
   const [nextBtn,setNextBtn] = useState(false)
   
 
   
   const [timeLeft, setTimeLeft] = useState(null);
   const [trackTimeLeft, setTrackTimeLeft] = useState(null);
   const [completionPopup,setCompletionPopup] = useState(false);
   const [upadateFilelist,setUpdateFileList] = useState(0);

   const [playstate,setPlayState] = useState([]);
   const [errorState,setErrorState] = useState([])

   const toggleDeletePopup = (data)=>{
     setDeletePopup(data)
   }

   const setFilesGlobal = (files) =>{
     setFiles(files)
   }
  
   useEffect(()=>{
     hidedashboard(false)
     nav("ReleaseMusic")
   }) 

   const [height,setHeight] = useState(document.body.scrollHeight)

   
   function topFunction() {
     document.body.scrollTop = 0; // For Safari
     document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
   }

  
      

   const handleResize = () => {
     // console.log(window.innerWidth)
     setDimensions({
     width: window.innerWidth,
     height: window.innerHeight,
     });
     if(window.innerWidth>=1024){
       setToggleDashboard(false)
     }
   }

  
   useEffect(()=>{

   },[trackartists])

  

   const changeAlbumLanguageHandler = value => {
     setAlbumLanguage(value)
   }


   {/** Use Effect functions */}
   useEffect(() => {
     // setHeight(ref.current.clientHeight)
     topFunction()
     console.log(decodeToken(cookies.get('token')))
     
     if(decodeToken(cookies.get('token')).info!==undefined){
       if(decodeToken(cookies.get('token')).info.artistName!==undefined){
         getArtistId(decodeToken(cookies.get('token')).info.artistName).then((res)=>{
           setArtistId(res.data.artist[0].id)
         }) 
         setArtistname(decodeToken(cookies.get('token')).info.artistName)
       }
     }
   window.addEventListener("resize", handleResize, false);

     if(cookies.get("artistname").length!==0){
       getLabelId()
       setPageNo(1)
       navigate("/dashboard/label/releasemusic/uploadtracks")
     }
     setFormatContainerClass("FormatDetailsModule")
     if(prevInfo==="Music" && sharedData.length!==0){
       console.log()
       console.log(sharedData)
       console.log(sharedData.assets)
       console.log(sharedData.name)
       setProgress()
       // createFugaProduct(sharedData.id)
       // fetch(sharedData.assets[0].songUrl)
       // .then((res) => res.blob())
       // .then((myBlob) => {
       //   const myFile = new File([myBlob], 'audio.wav', {type: myBlob.type});
       //   // console.log(myFile)
       // });
     }
 },[])

 useEffect(() => {
 console.log("Change in path")
 console.log(location.pathname)
 },[location.pathname])


 const setProgress = () =>{
   console.log(sharedData)
   console.log(sharedData.assets)
   setProductId(sharedData.id)
   if(sharedData.assets.length!==0 && sharedData.image_url===undefined){
      var temp=[]
      const itr = sharedData.assets
      itr.map((item,index)=>{
       fetch(item.songUrl)
       .then((res) => res.blob())
       .then((myBlob) => {
         const myFile = new File([myBlob], 'file '.concat(index+1), {type:"audio/wav"});
         temp.push({
             "Asset_id":null,
             "Tracktitle":"",
             "Asset_file":myFile,
             "Arists":[],
             "ArtistIds":[],
             "Contributors":[],
             "ContributorIds":[],
             "Publishers":[],
             "PublisherIds":[],
             "Lyrics":"",
             "AudioLanguage":"",
             "MetadataLanguage":"",
             "ExplicitContent":"",
             "Collaborators":[],
             "CollaboratorIds":[],
             "IsCollaborator":false,
             "isDragging":false,
             "isPlaying":false
         })
       })
      })
      setFiles(temp)
      setTrackUploaded(true)
      navigate("/Dashboard/releasemusic/uploadtracks")
   } 

   if(sharedData.image_url!==undefined && sharedData.name===undefined){
     var temp=[]
     const itr = sharedData.assets
     itr.map((item,index)=>{
      fetch(item.songUrl)
      .then((res) => res.blob())
      .then((myBlob) => {
        const myFile = new File([myBlob], 'file '.concat(index+1), {type: "audio/wav"});
        temp.push({
            "Asset_id":null,
            "Tracktitle":"",
            "Asset_file":myFile,
            "Arists":[],
            "ArtistIds":[],
            "Contributors":[],
            "ContributorIds":[],
            "Publishers":[],
            "PublisherIds":[],
            "Lyrics":"",
            "AudioLanguage":"",
            "MetadataLanguage":"",
            "ExplicitContent":"",
            "Collaborators":[],
            "CollaboratorIds":[],
            "IsCollaborator":false,
            "isDragging":false,
            "isPlaying":false
        })
      })
     })
     setFiles(temp)
     setTrackUploaded(true)
     getimgfromurl(sharedData.image_url)
     navigate("/Dashboard/releasemusic/uploadphoto")
  } 

  if(sharedData.name!==undefined && sharedData.assets[0].details===undefined){
   var temp=[]
   const itr = sharedData.assets
   itr.map((item,index)=>{
    fetch(item.songUrl)
    .then((res) => res.blob())
    .then((myBlob) => {
      const myFile = new File([myBlob], 'file '.concat(index+1), {type: "audio/wav"});
      temp.push({
          "Asset_id":null,
          "Tracktitle":"",
          "Asset_file":myFile,
          "Arists":[],
          "ArtistIds":[],
          "Contributors":[],
          "ContributorIds":[],
          "Publishers":[],
          "PublisherIds":[],
          "Lyrics":"",
          "AudioLanguage":"",
          "MetadataLanguage":"",
          "ExplicitContent":"",
          "Collaborators":[],
          "CollaboratorIds":[],
          "IsCollaborator":false,
          "isDragging":false,
          "isPlaying":false
      })
    })
   })
   setFiles(temp)
   setTrackUploaded(true)
   // setAlbumImage([sharedData.image_url])
   // fetch(sharedData.image_url)
   // .then((res) => res.blob())
   // .then((myBlob) => {
   //   const myFile = new File([myBlob], 'file.jpg', {type: "image/jpeg"});
   //   console.log("LLLLLLLLLLLLLLLLLLLLLLLLLLLLLL")
   //   console.log(myFile)
   //   setAlbumImage([myFile])
   // })
   getimgfromurl(sharedData.image_url)
   setReleaseTitle(sharedData.name)
   setDistribute({value:sharedData.distributed_as,label:sharedData.distributed_as})
   setFormat({value:sharedData.release_format_type,label:sharedData.release_format_type})
   setGenre({value:sharedData.genre,label:sharedData.genre})
   navigate("/Dashboard/releasemusic/albumdetails")
 } 

 if(sharedData.assets[0].details!==undefined && sharedData.release_date===undefined){
   var temp=[]
   const itr = sharedData.assets
   itr.map((item,index)=>{
    fetch(item.songUrl)
    .then((res) => res.blob())
    .then((myBlob) => {
      const myFile = new File([myBlob], 'file '.concat(index+1), {type: "audio/wav"});
      temp.push({
          "Asset_id":null,
          "Tracktitle":item.details.name,
          "Asset_file":myFile,
          "Arists":[],
          "ArtistIds":[],
          "Contributors":[],
          "ContributorIds":[],
          "Publishers":[],
          "PublisherIds":[],
          "Lyrics":"",
          "AudioLanguage":"",
          "MetadataLanguage":"",
          "ExplicitContent":"",
          "Collaborators":[],
          "CollaboratorIds":[],
          "IsCollaborator":false,
          "isDragging":false,
          "isPlaying":false
      })
    })
   })
   setFiles(temp)
   setTrackUploaded(true)
   getimgfromurl(sharedData.image_url)
   setReleaseTitle(sharedData.name)
   setDistribute({value:sharedData.distributed_as,label:sharedData.distributed_as})
   setFormat({value:sharedData.release_format_type,label:sharedData.release_format_type})
   setGenre({value:sharedData.genre,label:sharedData.genre})
   navigate("/Dashboard/releasemusic/trackdetails")
 } 

 if(sharedData.release_date!==undefined){
   var temp=[]
   const itr = sharedData.assets
   itr.map((item,index)=>{
    fetch(item.songUrl)
    .then((res) => res.blob())
    .then((myBlob) => {
      const myFile = new File([myBlob], 'file '.concat(index+1), {type: "audio/wav"});
      temp.push({
          "Asset_id":null,
          "Tracktitle":item.details.name,
          "Asset_file":myFile,
          "Arists":[],
          "ArtistIds":[],
          "Contributors":[],
          "ContributorIds":[],
          "Publishers":[],
          "PublisherIds":[],
          "Lyrics":"",
          "AudioLanguage":"",
          "MetadataLanguage":"",
          "ExplicitContent":"",
          "Collaborators":[],
          "CollaboratorIds":[],
          "IsCollaborator":false,
          "isDragging":false,
          "isPlaying":false
      })
    })
   })
   setFiles(temp)
   setTrackUploaded(true)
   getimgfromurl(sharedData.image_url)
   setReleaseTitle(sharedData.name)
   setDistribute({value:sharedData.distributed_as,label:sharedData.distributed_as})
   setFormat({value:sharedData.release_format_type,label:sharedData.release_format_type})
   setGenre({value:sharedData.genre,label:sharedData.genre})
   console.log(String(sharedData.release_date).substring(0, 10))
   submitReleaseDate(String(sharedData.release_date).substring(0, 10))
   navigate("/Dashboard/releasemusic/releasedate")
 } 

 }

 const getimgfromurl  = async (url) => {
   try {
     console.log("Fetching image from URL:", url);

     const res = await fetch(url, { mode: 'cors' });
     if (!res.ok) {
         throw new Error(`HTTP error! status: ${res.status}`);
     }
     
     const contentType = res.headers.get("content-type");
     if (!contentType || !contentType.startsWith("image/")) {
         throw new Error(`Expected image content type but received ${contentType}`);
     }

     const blob = await res.blob();
     console.log("Blob obtained:", blob);

     const img = new Image();
     img.src = URL.createObjectURL(blob);
     console.log("Image source set to:", img.src);

     // Newer promise based version of img.onload
     await img.decode();

     console.log("Image decoded successfully");
     // document.body.append(img);
     setAlbumImage([blob])
     console.log(img)

     // Don't forget to revoke the blob URL when 
     // you no longer need it (to release memory)
     URL.revokeObjectURL(img.src);
     console.log("Blob URL revoked");
 } catch (error) {
     console.error("Error loading image:", error);
 }
 }

 useEffect(()=>{
   if(productId!==undefined){
     {/** review comment */}
     // submitAlbumDetails()
     // ConnectAssetstoProduct()
     // setAlbumReleaseDate()
     // setAlbumBarcode()
   }
   // submitAlbumDetails()
 },[productId])

 useEffect(() => {
  
 },[playstate])

 useEffect(() => {
  
 },[audiolength])

 useEffect(() => {
   console.log("Audio State Changed")
   console.log(audioplay)
 },[audioplay])

 useEffect(() => {
   console.log("Audio State Changed")
   console.log(audioplay)
 },[assetId])


 useEffect(()=>{

 },[upadateFilelist])

  
   {/*Timer for Completion popup*/}

   useEffect(() => {
     // exit early when we reach 0
     if (!timeLeft) return;
 
     if(timeLeft===1){
       console.log("TIME LEFT IS 1");
       setCompletionPopup(true)
     }
 
     if(timeLeft===0){
        console.log("TIME LEFT IS 0");
     }
 
     // save intervalId to clear the interval when the
     // component re-renders
     const intervalId = setInterval(() => {
 
       setTimeLeft(timeLeft - 1);
     }, 1000);
   // clear interval on re-render to avoid memory leaks
   return () => clearInterval(intervalId);
   // add timeLeft as a dependency to re-rerun the effect
   // when we update it
 }, [timeLeft]);


 {/*Timer for track upload*/}

 useEffect(() => {
   // exit early when we reach 0
   if (!trackTimeLeft) return;

   if(trackTimeLeft===1){
     console.log("TIME LEFT IS 1");
     setTrackUploaded(true)
   }

   if(trackTimeLeft===0){
      console.log("TIME LEFT IS 0");
   }

   // save intervalId to clear the interval when the
   // component re-renders
   const intervalId = setInterval(() => {

     setTrackTimeLeft(trackTimeLeft - 1);
   }, 1000);
 // clear interval on re-render to avoid memory leaks
 return () => clearInterval(intervalId);
 // add timeLeft as a dependency to re-rerun the effect
 // when we update it
}, [trackTimeLeft]);

 
   func(height)
   
   
 {/*Create product when files changes*/}
   useEffect(()=>{
     console.log("Updated File") 
     console.log(files)
     var plays=[]
     files.map((file)=>{
       plays.push(false)
     })
     setPlayState(plays)
     if(files.length===0){
       setTrackUploaded(false)
     }
   },[files])

   useEffect(()=>{
     console.log(albumImage)
  
   },[albumImage])


   

   {/*Enable next btn when all track details entered*/}
   useEffect(()=>{
     setNextBtn(true)
       files.map((file,index)=>{
         if(file.Tracktitle.length===0){
           setNextBtn(false)
         }
       })
   },[checkAssetArr])


   useEffect(()=>{

   },[releaseDate,originalReleaseDate,consumerReleaseDate,preorderDate])

   useEffect(()=>{
     console.log("Asset id update")
       console.log(assetId)
   },[refreshAsset])



 {/*Backend Calls*/}

 {/*Set Label ID as N3rve for now*/} 
   const getLabelId = () =>{
     axios({
       method:'get',
       url:"https://n3rve.fly.dev/metadata/labels?name=N3rve",
       headers:{
           Authorization: "Bearer ".concat(cookies.get("token"))
       }
   }).then(res=>{
     setLabelId(res.data.label[0]["id"])
   }).catch(e=>{
     console.log(e)
   })
   }


   {/*Create product object*/} 
   const createproduct = (savestate) =>{
     axios({
       method:'post',
       url:"https://n3rve.fly.dev/products",
       headers:{
           Authorization: "Bearer ".concat(cookies.get("token"))
       }
   }).then(res=>{
     console.log("In create Product")
     console.log(res) 
     {/** review comments */}
     setProductId(res.data.id)
     // setCoverImageId(res.data.cover_image.id)
     // chunkfiles(res.data.id)
     // chunkImagefiles(res.data.id,res.data.cover_image.id)
     files.map((file,index)=>{
         createAsset(savestate,res.data.id,file.Asset_file,index)
     })
   }).catch(e=>{
     console.log(e)
   })
   }



   {/*Create asset object and local asset obj*/} 
   const createAsset = (savestate,index,file,position) =>{
     axios({ 
       method:'post',
       url:"https://n3rve.fly.dev/assets/".concat(index),
       headers:{
           Authorization: "Bearer ".concat(cookies.get("token"))
       }
   }).then(res=>{
     console.log("In create Asset")
     console.log(res.data.id)
     console.log(albumImage[0])
     console.log(typeof(albumImage[0]))
     saveLocalAsset(index,res.data.id,file,savestate)
     // saveLocalAssetTest(index,res.data.id,file)
     if(savestate===2){
       saveLocalImage(index,res.data.id,albumImage[0],savestate)
     }
     if(savestate===3){
       saveLocalImage(index,res.data.id,albumImage[0],savestate)
       submitAlbumDetails(index)
     }
     if(savestate===4){
       saveLocalImage(index,res.data.id,albumImage[0],savestate)
       submitAlbumDetails(index)
       submittrackdetails(index,res.data.id,position)
     }
     if(savestate===5){
       saveLocalImage(index,res.data.id,albumImage[0],savestate)
       submitAlbumDetails(index)
       submittrackdetails(index,res.data.id,position)
       submitroyalty(index,res.data.id,position)
     }
     if(savestate===6 || savestate===7){
       saveLocalImage(index,res.data.id,albumImage[0],savestate)
       submitAlbumDetails(index)
       submittrackdetails(index,res.data.id,position)
       submitroyalty(index,res.data.id,position)
       setAlbumReleaseDate(index)
     }
     if(savestate===8){
       saveLocalImage(index,res.data.id,albumImage[0],savestate)
       submitAlbumDetails(index)
       submittrackdetails(index,res.data.id,position)
       submitroyalty(index,res.data.id,position)
       setAlbumReleaseDate(index)
       // createFugaProduct(index,res.data.id)
     }
     {/** review comment */}
     // submittrackdetails(productid,index,res.data.id)
     // submitroyalty(productid,index,res.data.id)
     // files[index].Asset_id=res.data.id
     // startUpload(res.data.audio.id,file,md5)
     // console.log(startUpload(res.data.audio.id))
     //  return startUpload(res.data.audio.id)
   }).finally(()=>{
     console.log("Operations complete")
   })
   .catch(e=>{
     console.log(e)
   })
   }

 

   {/*Start asset upload*/} 
   const startUpload = (id,file,md5,product_id) =>{
     axios({
       method:'post',
       url:"https://n3rve.fly.dev/upload/start",
       headers:{
           Authorization: "Bearer ".concat(cookies.get("token"))
       },
       data:{
         id: id,
         type: "audio"
       }
   }).then(res=>{
     console.log("In start upload")
     setUUid(res.data.id)
     uploadck(res.data.id,file,md5,product_id,id)
    }).catch(e=>{
     console.log(e)
   })
   }

   {/*Start image asset upload*/} 
   const startImageUpload = (id,file,md5) =>{
     console.log("In image upload")
     console.log(id)
     axios({
       method:'post',
       url:"https://n3rve.fly.dev/upload/start",
       headers:{
           Authorization: "Bearer ".concat(cookies.get("token"))
       },
       data:{
         id: id,
         type: "image"
       }
   }).then(res=>{
     console.log("In start upload")
     console.log(res)
     setUUid(res.data.id)
     uploadck(res.data.id,file,md5)
    }).catch(e=>{
     console.log(e)
   })
   }



   {/*upload Audio chunks*/} 
   const uploadck = async (uid,file,md5,product_id,id) =>{

     const chunkSize = 4194304
     var counter= 0
     var off =0
     var index = 0
     

     var chunkarr= []

     for(let start = 0;start<file.size; start+=chunkSize){
       var from = index *chunkSize
       var to = from + chunkSize
       console.log("To------------------From")
       console.log(from)
       console.log(to)

       const chunk = file.slice(from,to)
      
       chunkarr[index]={"chunk":chunk,"partindex":index,"partbyteindex":from}

    
   
       index=index+1
       
       
     }
   
     var reqarr =[]

     const chunkpromise = chunkarr.map((arrobj) =>{
       return new Promise((resolve,reject)=>{
         const reader = new FileReader();
         console.log("Chunk")
         console.log(arrobj.chunk)
         reader.onload = async (e) =>
         {
           const data = new Blob([e.target.result], { type: 'application/octet-stream' });
           var bodyFormData = new FormData();
           bodyFormData.append("uuid",String(uid))
           bodyFormData.append("filename",String(file.name))
           bodyFormData.append("partindex",arrobj.partindex)
           bodyFormData.append("partbyteoffset",arrobj.partbyteindex)
           bodyFormData.append("totalfilesize",file.size)
           bodyFormData.append("file",data)
           bodyFormData.append("chunksize",arrobj.chunk.size)
 
           console.log("DDDDDDDDDDDDDDDDDDDDDDDD")
           console.log("partindex:-".concat(arrobj.partindex))
           console.log("byteoffset:-".concat(arrobj.partbyteindex))
           console.log("chunk:-".concat(data))
           console.log("chunksize:-".concat(arrobj.chunk.size))

           
           try{
             const response= await axios.post("https://n3rve.fly.dev/upload/chunk",bodyFormData, {headers:{
                Authorization: "Bearer ".concat(cookies.get("token"))
               }}) 
               if(response.status===200){
                 resolve(response);
               }
            } catch(err){
              console.log(err)
              reject(err);
            }
           
         }

         reader.readAsArrayBuffer(arrobj.chunk)
        
     })
     })
    
     

     const chunkinfo = await Promise.all(chunkpromise);

     console.log(chunkinfo)

     console.log('COMPLETED FIle read'.concat(index));
     endUpload(uid,file.name,md5,product_id,id)
   }

   {/*upload Image chunks*/} 
   const uploadImgck = async (uid,file,md5) =>{

     const chunkSize = 4194304
     var counter= 0
     var off =0
     var index = 0
     

     var chunkarr= []

     for(let start = 0;start<file.size; start+=chunkSize){
       var from = index *chunkSize
       var to = from + chunkSize
       console.log("To------------------From")
       console.log(from)
       console.log(to)

       const chunk = file.slice(from,to)
      
       chunkarr[index]={"chunk":chunk,"partindex":index,"partbyteindex":from}

       index=index+1
       
     }
   
     var reqarr =[]

     const chunkpromise = chunkarr.map((arrobj) =>{
       return new Promise((resolve,reject)=>{
         const reader = new FileReader();
         console.log("Chunk")
         console.log(arrobj.chunk)
         reader.onload = async (e) =>
         {
           const data = new Blob([e.target.result], { type: 'application/octet-stream' });
           var bodyFormData = new FormData();
           bodyFormData.append("uuid",String(uid))
           bodyFormData.append("filename",String(file.name))
           bodyFormData.append("partindex",arrobj.partindex)
           bodyFormData.append("partbyteoffset",arrobj.partbyteindex)
           bodyFormData.append("totalfilesize",file.size)
           bodyFormData.append("file",data)
           bodyFormData.append("chunksize",arrobj.chunk.size)
 
           console.log("DDDDDDDDDDDDDDDDDDDDDDDD")
           console.log("partindex:-".concat(arrobj.partindex))
           console.log("byteoffset:-".concat(arrobj.partbyteindex))
           console.log("chunk:-".concat(data))
           console.log("chunksize:-".concat(arrobj.chunk.size))

           
           try{
             const response= await axios.post("https://n3rve.fly.dev/upload/chunk",bodyFormData, {headers:{
                Authorization: "Bearer ".concat(cookies.get("token"))
               }}) 
               if(response.status===200){
                 resolve(response);
               }
            } catch(err){
              console.log(err)
              reject(err);
            }
           
         }

         reader.readAsArrayBuffer(arrobj.chunk)
        
     })
     })
    
     

     const chunkinfo = await Promise.all(chunkpromise);

     console.log(chunkinfo)

     console.log('COMPLETED FIle read'.concat(index));
     endImageUpload(uid,file.name,md5)
   }

   {/*fire end image upload*/} 
   const endImageUpload = (uid,filename,mdsum) =>{

     axios({
       method:'post',
       url:"https://n3rve.fly.dev/upload/finish",
       headers:{
           Authorization: "Bearer ".concat(cookies.get("token"))
       },
       data:{
         uuid: String(uid),
         filename: String(filename),
         md5sum: String(mdsum)
       }
   }).then(res=>{
     console.log("In end upload")
     if(res.status===200){
       console.log(res)
     }
     
   }).catch(
     e=>
     console.log(e)
   )
   }

   {/*Save song file locally*/} 
   const saveLocalAsset = async (productid,assetid,file,savestate) =>{

     const chunk = file

     const chunkpromise = new Promise((resolve,reject)=>{
         const reader = new FileReader();
         console.log("Chunk")
         console.log(chunk)
         reader.onload = async (e) =>
         {
           const data = new Blob([e.target.result], { type: 'application/octet-stream' });
           var bodyFormData = new FormData();
           bodyFormData.append("file",data)
           bodyFormData.append("product_id",String(productid))
           bodyFormData.append("asset_id",String(assetid))
           console.log(String(assetid))
           console.log(String(productid)) 
           console.log(data)

           
           try{
             const response= await axios.post("https://n3rve.fly.dev/upload/song",bodyFormData, {headers:{
                Authorization: "Bearer ".concat(cookies.get("token"))
               }}) 
               if(response.status===200){
                 resolve(response);
               }
            } catch(err){
              console.log(err)
              reject(err);
            }
           
         }

         reader.readAsArrayBuffer(chunk)
        
     })
     
    
     const chunkinfo = await chunkpromise;

     
     console.log(chunkinfo)
     ChunkCount=ChunkCount+1
     
     console.log("Update to Upload count")
     console.log(ChunkCount)
     if(savestate===8 && ChunkCount===files.length+1){
         createFugaProduct(productid,assetid)
     }
   }

     {/*Save song file locally*/} 
     const saveLocalAssetTest = async (productid,assetid,file) =>{
       console.log("Testing")
       console.log(productid)
       console.log(assetid)
       var bodyFormData = new FormData();
       bodyFormData.append("file",file)
       bodyFormData.append("product_id",String(productid))
       bodyFormData.append("asset_id",String(assetid))

       axios({
         method:'post',
         url:"https://n3rve.fly.dev/upload/start",
         headers:{
             Authorization: "Bearer ".concat(cookies.get("token"))
         },
         bodyFormData
         }).then(response=>{
           if(response.status===200){
            console.log(response)
           }
         }).catch(e=>{
           console.log(e)
         })
   }

   {/*Save image file locally*/} 
   const saveLocalImage = async (productid,assetid,file,savestate) =>{

     const chunk = file

     const chunkpromise = new Promise((resolve,reject)=>{
         const reader = new FileReader();
         console.log("Image Upload")
         console.log(file.type)
         reader.onload = async (e) =>
         {
           const data = new Blob([e.target.result], { type: 'application/octet-stream' });
           var bodyFormData = new FormData();
           bodyFormData.append("file",file)
           bodyFormData.append("mimetype","image/png")
           // bodyFormData.append("mimetype",String(file.type))
           console.log("HHHHHHHHHHHHHHHHHHHHHHHHHH")
           console.log(String(file.type))
           // bodyFormData.append("product_id",String(productid))
           // bodyFormData.append("asset_id",String(assetid))
           
           try{
             const response= await axios.post("https://n3rve.fly.dev/products/".concat(productid).concat("/image"),
             bodyFormData, 
             {headers:{
                Authorization: "Bearer ".concat(cookies.get("token"))
               }}) 
             
               if(response.status===200){
                 resolve(response);
               }

            } catch(err){
              console.log(err)
              reject(err);
            }
           
         }

         reader.readAsArrayBuffer(chunk)
        
     })
     
    
     const chunkinfo = await chunkpromise;

     console.log(chunkinfo)
     ChunkCount=ChunkCount+1
     // setUploadChunkCount(uploadChunkCount+1)
     console.log("Update to Upload count")
     console.log(ChunkCount)
     if(savestate===8 && ChunkCount===files.length+1){
       createFugaProduct(productid,assetid)
     }
   }



   {/*fire endupload*/} 
   const endUpload = (uid,filename,mdsum,product_id,id) =>{
     console.log(typeof(uid))
     console.log(uid)
     console.log(typeof(filename))
     console.log(filename)
     console.log(typeof(mdsum))
     console.log(mdsum)
     axios({
       method:'post',
       url:"https://n3rve.fly.dev/upload/finish",
       headers:{
           Authorization: "Bearer ".concat(cookies.get("token"))
       },
       data:{
         uuid: String(uid),
         filename: String(filename),
         md5sum: String(mdsum)
       }
   }).then(res=>{
     console.log("In end upload")
     if(res.status===200){
       console.log(res)
     }
      saveFugaAsset(product_id,id)
   }).catch(
     e=>
     console.log(e)
   )
   }


    {/*Album release date*/} 
   const setAlbumReleaseDate=(productid)=>{
     if(releaseDate.length!==0){
       console.log("In Release Date")
       console.log(releaseDateUpload)
       axios({
         method:'post',
         // PENDING
         // url:"https://n3rve.fly.dev/products/".concat(productid).concat("/release_date"),
         url:"https://n3rve.fly.dev/products/w",
         headers:{
             Authorization: "Bearer ".concat(cookies.get("token"))
         }
         // PENDING
         // ,
         // data:{
         //   release_date:String(releaseDateUpload)
         // }
     }).then((response)=>{
       if(response.status===200){
         console.log("Release Date fired")
         console.log(response)
         setPageNo(7)
       }
     }).catch(function (e){
       console.log("RELEASE DATE ERROR")
       console.log(e.response)
     })    
     }
   }


 {/*set Album barcode*/} 
   const setAlbumBarcode=()=>{
     axios({
         method:'post',
         url:"https://n3rve.fly.dev/products/".concat(productId).concat("/barcode"),
         headers:{
             Authorization: "Bearer ".concat(cookies.get("token"))
         }
     }).then((response)=>{
       if(response.status===200){
         console.log(response)
       }
     }).catch(function (e){
       console.log(e.response)
     })    
   }

   {/*get Artist Id*/} 
   const getArtistId = async (name) =>{
     return await axios.get("https://n3rve.fly.dev/artists?name=".concat(name))  
   }


   {/*set Album Details*/} 
   const submitAlbumDetails = (productid) => {
     console.log("Submit product")
     console.log(consumerReleaseDate)
     console.log(preorderDate)
     // console.log(genre.value.toUpperCase())
     console.log(labelId)
     console.log(format.value)
     console.log(distributeAs.value)
     console.log(totalVolumes)
     console.log(typeof(totalVolumes))
     // console.log(albumLanguage.value.toString())
     console.log(explicitAlbumContent.value)
     console.log(typeof(explicitAlbumContent.value))
     var lang
     if( albumLanguage.value===undefined){
         lang=""
     }else{
         lang=albumLanguage.value.toString()
     }
    
     // if(explicitAlbumContent==="Yes)
     axios({
       method:'post',
       url:"https://n3rve.fly.dev/products/".concat(productid),
       headers:{
           Authorization: "Bearer ".concat(cookies.get("token"))
       },
       data:{
         name:releaseTitle.toString(), //*
         genre: genre.value.toUpperCase().toString(),//*
         label:5355516108,
         artists:[artistId],
         release_format_type:format.value.toString(),//*
         distribute_as:distributeAs.value.toString(), //*
         total_volumes:totalVolumes,
         compilation: switchChecked,
         parental_advisory:explicitAlbumContent.value,
         consumer_release_date: "2025-07-07",//*
         consumer_release_time:"23:20:44Z",
         preorder_date:"2025-04-07",
         original_release_date:"2025-07-07",//*
         c_line_year:Number(cCopyrightYear.value),//*
         c_line_text:cCopyrightText.toString(),//*
         p_line_year:Number(pCopyrightYear.value),//*
         p_line_text:pCopyrightText.toString(),//*
         language:"EN"
       }
   }).then((response)=>{
     if(response.status===200){
       console.log(response)
     }
   }).catch(function (e){
     console.log(e.response)
   })    
 
   }


   {/*set Track Details*/} 
   const submittrackdetails = (productid,assetid,index) =>{
     var exp=false
     if(files[index].ExplicitContent==="Yes"){
       exp=true
     }else{
       exp=false
     }
     
     var trackdata = {
       "name":files[index].Tracktitle.toString(),
       "genre":genre.value.toUpperCase(),
       "label":5355516108,
       "artists":[artistId],
       "song_writers":[artistId],
       "audioLocale":"ZXX",
       "language":"EN",
       "explicit":exp,
       "radio_edit":false,
       "price":14.7
     }
     console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%")
     console.log(trackdata)

     var artists = [];

     files[index].Arists.map((artist,ind)=>{
       if(ind===0){
         if(files[index].ArtistIds[ind]!==undefined){
           artists.push({id: files[index].ArtistIds[ind], primary: true})
         }
       }else{
         if(files[index].ArtistIds[ind]!==undefined){
           artists.push({id: files[index].ArtistIds[ind], primary: artist.isFeatured})
         }
       }
       
     })

     console.log("TEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE")
     console.log(artists)

     var contributors = [];

     files[index].Contributors.map((contributor,ind)=>{
       if(ind===0){
         if(files[index].ContributorIds[ind]!==undefined){
           contributors.push({person: files[index].ContributorIds[ind], role: "COMPOSER"})
         }
         contributor.roles.map((role,roleindex)=>{
           if(role.value!=="COMPOSER"){
             if(files[index].ContributorIds[ind]!==undefined){
               contributors.push({person: files[index].ContributorIds[ind], role: role.value})
             }
           }
         })
       }else{
         contributor.roles.map((role)=>{ 
           if(files[index].ContributorIds[ind]!==undefined){
             contributors.push({person: files[index].ContributorIds[ind], role: role.value})
           }
         })
       }
       
     })

     console.log("TAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA")
     console.log(contributors)


     var publishers = [];

     if(files[index].Publishers.length!==0){
       files[index].Publishers.map((publisher,ind)=>{
           if(files[index].PublisherIds[ind]!==undefined){
             publishers.push({person: files[index].PublisherIds[ind],publishing_house: Number(publisher.publisherid)})
           }
          })
     }

     console.log("TOOOOOOOOOOOOOOOOOOOOOOOOOOOO")
     console.log(publishers)
   
     var instrumentperformers =[]

     files[index].Contributors.map((contributor,ind)=>{
           contributor.instruments.map((instrument,instindex)=>{
               if(files[index].ContributorIds[ind]!==undefined){
                 instrumentperformers.push({person_id: files[index].ContributorIds[ind], instrument: instrument.value})
               }
           })
     })

     console.log("TXXXXXXXXXXXXXXXXXXXXXXXXXXXX")
     console.log(instrumentperformers)
       


     axios({
           method:'post',
           url:"https://n3rve.fly.dev/assets/".concat(productid).concat("/").concat(assetid),
           headers:{
             Authorization: "Bearer ".concat(cookies.get("token"))
           },
           data:{
             name:files[index].Tracktitle.toString(),
             genre:genre.value.toUpperCase().toString(),
             artists:artists,
             contributors:contributors,
             publishers:publishers,
             instrument_performers:instrumentperformers,
             audioLocale:"ZXX",
             language:files[index].AudioLanguage.value,
             lyrics: files[index].Lyrics.toString()
           }
       }).then((response)=>{
         if(response.status===200){
           console.log("Track details")
           console.log(response)
         }
       }).catch(function (e){
         console.log(e.response)
       })   
   }



   {/*set Track royalty split*/} 
   const submitroyalty = (productid,assetid,id) => {
     var splitdata=[]
      files[id].Collaborators.map((collab,index)=>{
       splitdata.push({artist_id:files[id].CollaboratorIds[index],percent:collab.percent})
     })
     console.log(splitdata)
     axios({
           method:'post',
           url:"https://n3rve.fly.dev/assets/".concat(productid).concat("/").concat(assetid).concat("/split"),
           headers:{
               Authorization: "Bearer ".concat(cookies.get("token"))
           },
           data:splitdata
       }).then((response)=>{
         if(response.status===200){
           console.log("Submit royalty ")
           console.log(response)
         }
       }).catch(function (e){
         console.log("ROYALTY ERROR")
         console.log(e.response)
       })   
   }

    {/*Create Product in Fuga*/} 
    const createFugaProduct = (productid,assetid) => {
     axios({
           method:'post',
           url:"https://n3rve.fly.dev/products/".concat(productid).concat("/create"),
           headers:{
               Authorization: "Bearer ".concat(cookies.get("token"))
           }
       }).then((response)=>{
         if(response.status===200){
           console.log("Create Fuga Product")
           console.log(response)
           console.log(response.data)
           console.log(response.data.product_id)
          
           files.map((file,index)=>{
             createFugaAsset(response.data.product_id,assetid)
           })
           createFugaBarcode(response.data.product_id)
         }
       }).catch(function (e){
         console.log(e.response)
       })   
   }

    {/*Create Fuga Barcode*/} 
    const createFugaBarcode = (productid) => {
     axios({
           method:'post',
           url:"https://n3rve.fly.dev/products/".concat(productid).concat("/barcode"),
           headers:{
               Authorization: "Bearer ".concat(cookies.get("token"))
           }
       }).then((response)=>{
         if(response.status===200){
           console.log("Finalize Fuga Product")
           console.log(response)
           chunkImagefiles(response.data.cover_image.id)
         }
       }).catch(function (e){
         console.log(e.response)
       })   
   }


     {/*Create Asset in Fuga*/} 
     const createFugaAsset = (productid,assetid) => {
       axios({
             method:'post',
             url:"https://n3rve.fly.dev/assets/".concat(productid).concat("/").concat(assetid).concat("/create"),
             headers:{
                 Authorization: "Bearer ".concat(cookies.get("token"))
             }
         }).then((response)=>{
           if(response.status===200){
             console.log("Create Fuga Asset")
             console.log(response)
             console.log(typeof(response.data.id))
             chunkfiles(response.data.asset_id,productid)
           }
         }).catch(function (e){
           console.log(e.response)
         })   
     }

      {/*Save Product in Fuga*/} 
      const saveFugaAsset = (productid,assetid) => {
       axios({
             method:'post',
             url:"https://n3rve.fly.dev/assets/".concat(productid).concat("/").concat(assetid).concat("/save"),
             headers:{
                 Authorization: "Bearer ".concat(cookies.get("token"))
             }
         }).then((response)=>{
           if(response.status===200){
             console.log("Finalized Fuga Asset")
             console.log(response)
           }
         }).catch(function (e){
           console.log(e.response)
         })   
     }






   {/*Functions*/} 

   {/*Create Local Assets*/} 
   const SubmitReleaseMusic =  () =>{
       createproduct(8)
   }
   


   {/*Delete Song*/} 
   const deletesong =  (songid) =>{
       setFiles(files.filter((file,index)=>{
         console.log("^^^^^^^^^^^")
         console.log(file)
         console.log(songid)
         console.log(index)
         return index!==songid
       })
       )
       setAudioLength(audiolength.filter((file,index)=>{
         return index!==songid
       }))
   }

   {/*Chunk audio files*/} 
   const chunkfiles = async (id,product_id) =>{

      
     const Filepromise = files.map((file,index)=>{
        return new Promise((resolve,reject)=>{

           var reader = new FileReader();
           setOffset(0)
           setFilename(file.Asset_file.name)
           
           reader.addEventListener(
             'load',
             function () {
                 var wordArray = CryptoJS.lib.WordArray.create(this.result);
                 console.log(CryptoJS.MD5(wordArray).toString())
                 setMd5(CryptoJS.MD5(wordArray).toString())
                 // createAsset(productid,index,file.Asset_file,CryptoJS.MD5(wordArray).toString())
                 startUpload(id,file.Asset_file,CryptoJS.MD5(wordArray).toString(),product_id)
             }
           ); 
           reader.readAsArrayBuffer(file.Asset_file);   
           setRefreshAsset(Math.random())
           }
       )
       })

       const fileinfo = await Promise.all(Filepromise);
 
       console.log('COMPLETED Upload Completely');
   }


   {/*Chunk image files*/} 
   const chunkImagefiles = async (productid) =>{

      
     const Filepromise = albumImage.map((file)=>{
        console.log(file)
        return new Promise((resolve,reject)=>{

           var reader = new FileReader();
           setOffset(0)
           setFilename(file.name)
           
           reader.addEventListener(
             'load',
             function () {
                 var wordArray = CryptoJS.lib.WordArray.create(this.result);
                 console.log(CryptoJS.MD5(wordArray).toString())
                 setMd5(CryptoJS.MD5(wordArray).toString())
                 startImageUpload(productid,file,CryptoJS.MD5(wordArray).toString())
                 // createImageAsset(productid,coverImageId,file,CryptoJS.MD5(wordArray).toString())
             }
           ); 
           reader.readAsArrayBuffer(file);   
           setRefreshAsset(Math.random())
           }
       )
       })

       const fileinfo = await Promise.all(Filepromise);
 
       console.log('COMPLETED Upload Completely');
   }


   {/** Album details form error check */}
   const errorCheck = () =>{
     console.log("In Submit")
     console.log(genre.length)
     console.log(distributeAs.length)
     console.log(format.length)
     var titleerror
     var genreerror
     var distributeerror
     var formaterror

      if(releaseTitle.length===0){
       setReleaseTitleError(true)
       titleerror = true
      }else{
       setReleaseTitleError(false)
       titleerror = false
      }


      if(genre.length!==undefined){
       setGenreError(true)
       genreerror = true
      }else{
       setGenreError(false)
       genreerror = false
      }

      if(distributeAs.length!==undefined){
       setDistibuteError(true)
       distributeerror= true
      }else{
       setDistibuteError(false)
       distributeerror= false
      }

      if(format.length!==undefined){
       setFormatError(true)
       formaterror=true
      }else{
       setFormatError(false)
       formaterror=false
      }
      return [titleerror,genreerror,distributeerror,formaterror]
   }
   
   const handleformsubmit = (titleerror,genreerror,distributeerror,formaterror)=>{
     if(!titleerror && !genreerror && !distributeerror && !formaterror){
       submitAlbumDetails()
     }
   }


   {/** Album Release Date error check */}
   const submitReleaseDate = (value) =>{
     
     const date = new Date(value.concat("T00:00"))
    
     console.log(date)
    
     const today = new Date()
    
     setReleaseDateUpload("".concat(date.getFullYear()).concat("-").concat(getMonthNo(date.getMonth()).concat("-").concat(getDateNo(date.getDate()))))
     console.log("".concat(date.getFullYear()).concat("-").concat(getMonthNo(date.getMonth()).concat("-").concat(getDateNo(date.getDate()))))
     console.log(date)
     console.log(today)
     let Difference_In_Time = date.getTime() - today.getTime();
     let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
     console.log(Difference_In_Days)
     if(Difference_In_Days>30){
       setReleaseDateError(3)
     }else{
       setReleaseDateError(2)
     }
     setReleaseDate(getMonthTxt(date.getMonth()).concat(" ").concat(date.getDate()).concat(", ").concat(date.getFullYear()))
 }



 







 
/**TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT */
{/** Track details submit */}
 const handleSubmitTrackDetails = () =>{

   if(Trackname.length!==0){
     files[popupId].Tracktitle = Trackname
   }
   
   if(lyrics.length!==0){
     files[popupId].Lyrics = lyrics
   }

   files[popupId].AudioLanguage = AudioLanguage.value

   if(trackMetadatLanguage.length!==0){
     files[popupId].MetadataLanguage = trackMetadatLanguage.value
   }

   if(explicitContent.length!==0){
     files[popupId].ExplicitContent = explicitContent.value  
   }

   if(trackartists.length!==0){
     files[popupId].Arists = trackartists
   }

   if(trackContributors.length!==0){
     files[popupId].Contributors = trackContributors
   }

   if(trackPublishers.length!==0){
     files[popupId].Publishers = trackPublishers
   }





   console.log("In handle submit")
   console.log(files[popupId])

 }



{/** Submit track details and royalty*/}
 const ConnectAssetstoProduct = () =>{
   files.map((file,index)=>{
     // submittrackdetails(index)
     submitroyalty(index)
   })
 }


   const onButtonClick = () => {
       inputRef.current.click();
   };

   const onAddTrackClick = () => {
     addRef.current.click();
 };







 {/** Date Manipulation */}
   const getMonthTxt = (num) =>{
     switch(num){
       case 0: return "Jan"; break;
       case 1: return "Feb"; break;
       case 2: return "Mar"; break;
       case 3: return "Apr"; break;
       case 4: return "May"; break;
       case 5: return "Jun"; break;
       case 6: return "Jul"; break;
       case 7: return "Aug"; break;
       case 8: return "Sep"; break;
       case 9: return "Oct"; break;
       case 10: return "Nov"; break;
       case 11:return "Dec"; break;
     }
   }

   const getMonthNo = (num) =>{
     switch(num){
       case 0: return "01"; break;
       case 1: return "02"; break;
       case 2: return "03"; break;
       case 3: return "04"; break;
       case 4: return "05"; break;
       case 5: return "06"; break;
       case 6: return "07"; break;
       case 7: return "08"; break;
       case 8: return "09"; break;
       case 9: return "10"; break;
       case 10: return "11"; break;
       case 11:return  "12"; break;
     }
   }

   const getDateNo = (num) =>{
     switch(num){
       case 1: return "01"; break;
       case 2: return "02"; break;
       case 3: return "03"; break;
       case 4: return "04"; break;
       case 5: return "05"; break;
       case 6: return "06"; break;
       case 7: return "07"; break;
       case 8: return "08"; break;
       case 9: return "09"; break;
       default: return "".concat(num); break;
     }
   }

   const handleSavePopup = (val)=>{
     console.log("Status of Track Uploaded")
     console.log(trackUploaded)
     if(trackUploaded){
       console.log("Firess")
       setSaveProgressPopup(true)
       setExitAction(val)
      
     }else{
       hidedashboard(true)
       nav(val)
       if(val==="Home"){
         navigate("/Dashboard", { state: { fromAccountPage: false,fromLogin:false}})
       }
       if(val==="Music"){
         navigate("/Dashboard/music")
       }
       if(val==="Analytics"){
         navigate("/Dashboard/analytics")
       }
       if(val==="Wallet"){
         navigate("/Dashboard/money")
       }
       if(val==="PromoteYourself"){
         navigate("/Dashboard/promoteyourself")
       }
       if(val==="Exclusives"){
         navigate("/Dashboard/exclusives")
       }
       if(val==="Settings"){
         navigate("/Dashboard/settings")
       }
       if(val==="Support"){
         navigate("/Dashboard/support")
       }
      
     }

   }

   const handleSaveAction = ()=>{
       if(pagePath==="/Dashboard/releasemusic/uploadtracks" && trackUploaded){
         createproduct(1)
       }
       if(pagePath==="/Dashboard/releasemusic/uploadphoto" && albumImage.length!==0){
         createproduct(2)
       }
       if(pagePath==="/Dashboard/releasemusic/uploadphoto" && albumImage.length===0){
         createproduct(1)
       }
       if(pagePath==="/Dashboard/releasemusic/albumdetails" && releaseTitle.length!==0 && genre.length!==0 && format.length!==0 && distributeAs.length!==0){
         createproduct(3)
       }
       if(pagePath==="/Dashboard/releasemusic/albumdetails" && (albumImage.length===0 || genre.length!==0 || format.length!==0 || distributeAs.length!==0 )){
         createproduct(2)
       }
       if(pagePath==="/Dashboard/releasemusic/trackdetails"){
         createproduct(4)
       }
       if(pagePath==="/Dashboard/releasemusic/royaltysplit"){
         createproduct(5)
       }
       if(pagePath==="/Dashboard/releasemusic/releasedate" && releaseDate.length!==0){
         createproduct(6)
       }
       if(pagePath==="/Dashboard/releasemusic/albumsummary"){
         createproduct(7)
       }

       if(exitAction==="Home"){
         navigate("/Dashboard", { state: { fromAccountPage: false,fromLogin:false}})
       }
       if(exitAction==="Music"){
         navigate("/Dashboard/music")
       }
       if(exitAction==="Analytics"){
         navigate("/Dashboard/analytics")
       }
       if(exitAction==="Wallet"){
         navigate("/Dashboard/money")
       }
       if(exitAction==="PromoteYourself"){
         navigate("/Dashboard/promoteyourself")
       }
       if(exitAction==="Exclusives"){
         navigate("/Dashboard/exclusives")
       }
       if(exitAction==="Settings"){
         navigate("/Dashboard/settings")
       }
       if(exitAction==="Support"){
         navigate("/Dashboard/support")
       }
      
   }

   const handleLogout = () =>{
     cookies.set('token', undefined)
     cookies.set('staysignedin', false)
     navigate("/")
   }

   function closeLogoutPopup(){
     setLogoutPopup(false)
   }


   function closeSavePopup(){
     setSaveProgressPopup(false)
   }

   function closeDeletePopup(){
     setDeletePopup(false)
   }

   useEffect(()=>{
     if(saveProgressPopup){
       console.log("Popup should open")
     }
    
   },[saveProgressPopup])


    return (
      <div style={{height:'100vh',overflowY:'scroll'}}>
             <ReactModal
          isOpen={LogoutPopup}
          overlayClassName="Overlay"
          contentLabel="Example Modal"
          onRequestClose={closeLogoutPopup} // closes the modal when the user presses the escape key
          shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
          style={{
            content:{
              width:'42.125em',
              height:'9.81em',
              margin:'auto',
              backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              justifyContent:'space-between',
              borderRadius:'8px',
              border:'0.5px solid rgba(255,255,255,25%)'
            }
          }}
        >
          <div className='LogoutPopupHeader'>
          {t('Areyousureyouwant')}
          </div>
          <img src={crossicon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setLogoutPopup(false)}/>
          <div style={{display:'flex',alignSelf:'flex-end'}}>
            <div className='CancelBtn' onClick={()=>setLogoutPopup(false)}>
            {t('Cancel')}
            </div>
            <div className='LogoutBtn' onClick={()=>handleLogout()}>
            {t('Logoutpop')} 
            <div className="PostLoginBtnOverlay"/>
            </div>
          </div>
        </ReactModal>

        {
           dimensions.width < 1024  &&
           <div className='DashboardDrawer' style={{marginLeft:'0em',height:'5em'}}>
            <div style={{display:'flex',flexDirection:'row',height:'3.01em',alignItems:'center',marginTop:'1.5em',position:'relative'}}>
              <img src={NavbarDesc} style={{height:'2.14em',width:'2.14em',marginLeft:'1em',cursor:'pointer'}} onClick={()=>setToggleDashboard(true)} />
              <img src={N3rveLogo} style={{height:'1.31em',width:'7.18em',marginLeft:'1em'}}/>
              {
                toggleDashBoard &&
                <div style={{position:'absolute',backgroundImage:'linear-gradient(90deg, rgba(19,19,23,1) 0%, rgba(16,16,20,0) 100%)',backgroundColor:'rgba(0,0,0,90%)',width:'20em',top:'-1.5em'}}>
                <img src={DashNavbarCross} style={{width:'2.14em',height:'2.14em',marginLeft:'1em',marginTop:'2em',marginBottom:'2.04em',cursor:'pointer'}} onClick={()=>setToggleDashboard(false)}/>
                
                
                  <div className='DashboardMenuItem' onClick={()=>{navigate("/dashboard/label");setToggleDashboard(false)}} style={{cursor:'pointer'}}>{t('Home')}</div>

                  <div className='DashboardMenuItemSelected' onClick={()=>{navigate("/dashboard/label/releasemusic");setToggleDashboard(false)}} style={{cursor:'pointer'}}>{t('Releasemusic')}</div>

                  <div className='DashboardMenuItem' onClick={()=>{navigate("/dashboard/label/catalog");setToggleDashboard(false)}} style={{cursor:'pointer'}}>Catalog</div>
                
                  <div className='DashboardMenuItem' onClick={()=>{navigate("/dashboard/label/roster");setToggleDashboard(false)}} style={{cursor:'pointer'}}>Artist Roster</div>
                 
                  <div className='DashboardMenuItem' onClick={()=>{navigate("/dashboard/label/accounting");setToggleDashboard(false)}} style={{cursor:'pointer'}}>Accounting</div>
               
                  <div className='DashboardMenuItem' onClick={()=>{navigate("/dashboard/label/promoteartist");setToggleDashboard(false)}} style={{cursor:'pointer'}}>Promote Your Artists</div>
                
                  <div style={{display:'flex',flexDirection:'row',alignItems:'center',cursor:'pointer'}} className='DashboardMenuItem'  onClick={()=>{navigate("/dashboard/label/exclusives");setToggleDashboard(false)}}>
                    <div>{t('Exclusives')}</div>
                    {
                      cookies.get('lang') === 'en' && <img src={ProTag} alt="Pro Tag" className='ProTag' /> 
                    }
                    {
                      cookies.get('lang') === 'jp' && <img src={JpProTag} alt="Pro Tag" className='ProTag' /> 
                    }
                    
                  </div>
                 
                  <div className='DashboardSettingItem' onClick={()=>{navigate("/dashboard/label/settings");setToggleDashboard(false)}} style={{cursor:'pointer',marginTop:'0.3em'}}>{t('Settings')}</div>
                    
                  <div className='DashboardSettingItem' onClick={()=>{navigate("/help");setToggleDashboard(false)}} style={{cursor:'pointer'}}>{t('Support')}</div>

                  
                    
                    <div className='DashboardSettingItem' style={{cursor:'pointer',marginBottom:'4em'}} onClick={()=>setLogoutPopup(true)}>{t('Logout')}</div>
                    

                    <div style={{position:'relative',marginLeft:'0.3em'}}>
                      {
                        languagedropdown &&
                        <div style={{backgroundColor:'transparent',position:'absolute',marginTop:'-8.5em',marginLeft:'10em'}} onMouseLeave={()=>setLanguageDropdown(false)} >
                          <div style={{backgroundColor:'#1D2024',marginTop:'0.4em',paddingBottom:'0.3em',border:'1px #8C8C8C solid',borderRadius:'8px',paddingTop:'0.3em',paddingBottom:'0.3em',paddingLeft:'0.5em',paddingRight:'0.5em',position:'absolute',top:'3em',marginLeft:'-1em'}} onMouseOver={()=>setLanguageDropdown(true)} onMouseLeave={()=>setLanguageDropdown(false)}>
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'0.625em'}}>
                              <img src={EnIcon} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                              <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguage('English');setLanguageDropdown(!languagedropdown)}}>English</div>
                            </div>

                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'0.625em'}}>
                              <img src={JapIcon} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                              <div value={'jp'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('jp'); cookies.set('lang', 'jp');setLanguage('日本語');setLanguageDropdown(!languagedropdown)}}>日本語</div>
                            </div>
                          </div>
                        </div>
                      }
                  
                      <div className='DashboardLanguageItem'>Select language <span style={{textDecoration:'underline',cursor:'pointer'}} onClick={()=>setLanguageDropdown(!languagedropdown)}>{language}</span></div>
                      <div className='DashboardCopyrightItem' style={{marginLeft:'0.5em'}}>&copy; 2023 N3RVE {t('Allrightsreserved')}</div>
                    </div>

              </div>
              }
              
          </div> 
          
         </div>
        } 

        {
            dimensions.width >= 1024 &&
            <div className='DashboardDrawer' style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/xc7fkmxojffjwlwhwd0c")`,position:'fixed',marginLeft:'calc(max(-20em, -22.5%))'}} >
            <div>
            <img src={N3rveLogo} alt="Nerve Logo" className='Logo' onClick={()=>{navigate("/")}} style={{width:'6.15em',height:'1.125em',cursor:'pointer'}}/>
            

      
            

           
              <div className='DashboardMenuItem' onClick={()=>{navigate("/dashboard/label", { state: { fromAccountPage: false,fromLogin:false}});}} style={{cursor:'pointer'}}>{t('Home')}</div>
           

          
            <div className='DashboardMenuItemSelected' style={{cursor:'pointer'}}>{t('Releasemusic')}</div>
        

         

            <div className='DashboardMenuItem' onClick={()=>{navigate("/dashboard/label/catalog");}} style={{cursor:'pointer'}}>Catalog</div>
          
            <div className='DashboardMenuItem' onClick={()=>{navigate("/dashboard/label/roster");}} style={{cursor:'pointer'}}>Artist Roster</div>
          
            <div className='DashboardMenuItem' onClick={()=>{navigate("/dashboard/label/accounting");}} style={{cursor:'pointer'}}>Accounting</div>
          
            <div className='DashboardMenuItem' onClick={()=>{navigate("/dashboard/label/promoteartist");}} style={{cursor:'pointer'}}>Promote Your Artists</div>
         


       
            <div style={{display:'flex',flexDirection:'row',alignItems:'center',cursor:'pointer'}} className='DashboardMenuItem'  onClick={()=>{navigate("/dashboard/label/exclusives");}}>
            <div>{t('Exclusives')}</div>
            {
              cookies.get('lang') === 'en' && <img src={ProTag} alt="Pro Tag" className='ProTag' /> 
            }
            {
              cookies.get('lang') === 'jp' && <img src={JpProTag} alt="Pro Tag" className='ProTag' /> 
            }
            
          </div>
        

          <div className='DashboardSettingItem' onClick={()=>{navigate("/dashboard/label/settings");}} style={{cursor:'pointer',marginTop:'0.3em'}}>{t('Settings')}</div>
          

          <div className='DashboardSettingItem' onClick={()=>{navigate("/help");}} style={{cursor:'pointer'}}>{t('Support')}</div>
         

         
        
           
            
            <div className='DashboardSettingItem' style={{cursor:'pointer'}} onClick={()=>setLogoutPopup(true)}>{t('Logout')}</div>
            </div>

            <div style={{position:'relative'}}>
              {
                languagedropdown &&
                <div style={{backgroundColor:'transparent',position:'absolute',marginTop:'-8.5em',marginLeft:'10em'}} onMouseLeave={()=>setLanguageDropdown(false)} >
                  <div style={{backgroundColor:'#1D2024',marginTop:'0.4em',paddingBottom:'0.3em',border:'1px #8C8C8C solid',borderRadius:'8px',paddingTop:'0.3em',paddingBottom:'0.3em',paddingLeft:'0.5em',paddingRight:'0.5em',position:'absolute',top:'3em',marginLeft:'-1em'}} onMouseOver={()=>setLanguageDropdown(true)} onMouseLeave={()=>setLanguageDropdown(false)}>
                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'0.625em'}}>
                      <img src={EnIcon} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                      <div value={'en'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('en');cookies.set('lang', 'en');setLanguage('English');setLanguageDropdown(!languagedropdown)}}>English</div>
                    </div>

                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'0.625em'}}>
                      <img src={JapIcon} style={{width:'24px',height:'24px',borderRadius:'99px'}}/>
                      <div value={'jp'} className='LanguageOption'  onClick={()=>{ i18next.changeLanguage('jp'); cookies.set('lang', 'jp');setLanguage('日本語');setLanguageDropdown(!languagedropdown)}}>日本語</div>
                    </div>
                  </div>
                </div>
              }
          
              <div className='DashboardLanguageItem'>Select language <span style={{textDecoration:'underline',cursor:'pointer'}} onClick={()=>setLanguageDropdown(!languagedropdown)}>{language}</span></div>
              <div className='DashboardCopyrightItem'>&copy; 2023 N3RVE {t('Allrightsreserved')}</div>
            </div>
        </div>
        }
  
          


        
       
      {/** Popups */}

       <ReactModal
                            isOpen={saveProgressPopup}
                            overlayClassName="Overlay"
                            contentLabel="Example Modal"
                            onRequestClose={closeSavePopup} // closes the modal when the user presses the escape key
                            shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                            style={{ 
                                content:{
                                width:'27.375em',
                                height:'21.68em',
                                margin:'auto',
                                backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                borderRadius:'8px',
                                border:'0.5px solid rgba(255,255,255,25%)'
                                }
                            }}
                            >
                                
                                <div className="popupheaderinfo">Save your progress?</div>
                                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>{setSaveProgressPopup(false)}}/>
                                   

                                

                                    <span className="SettingPopupH3" style={{width:'80%',marginTop:'2em',marginLeft:'-1.6em'}}>Do you want to save your current progress as a draft? You can return anytime to pick up right where you left off.</span>
                                   
                                   
                                    <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer',width:'23.37em',marginTop:'2em'}} onClick={()=>{shareData([]);handleSaveAction();setSaveProgressPopup(false);hidedashboard(true)}}>
                                            Yes, Save
                                            <div className="PostLoginBtnOverlay"/>
                                    </div>
                                    
                                    <div className="GoBackBtn" style={{cursor:'pointer',width:'23.37em',marginTop:'1em'}} onClick={()=>{shareData([]);setSaveProgressPopup(false);hidedashboard(true)}}>
                                            Leave without Saving 
                                    </div>

                                       
                                   
      </ReactModal>

      <ReactModal
                            isOpen={deletePopup}
                            overlayClassName="Overlay"
                            contentLabel="Example Modal"
                            onRequestClose={closeDeletePopup} // closes the modal when the user presses the escape key
                            shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                            style={{ 
                                content:{
                                width:'32.18em',
                                height:'12.68em',
                                margin:'auto',
                                backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                borderRadius:'8px',
                                border:'0.5px solid rgba(255,255,255,25%)'
                                }
                            }}
                            >
                                
                                <div className="popupheaderinfo">Remove?</div>
                                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>{setDeletePopup(false)}}/>
                                   

                                

                                    <span className="SettingPopupH3" style={{width:'80%',marginTop:'2em',marginLeft:'-1.6em'}}>Do you want to remove this item from the list?</span>
                                   
                                   
                                   
                                    <div style={{display:'flex',flexDirection:'row',marginTop:'1em'}}>
                                        <div className="GoBackBtn" style={{paddingTop:'0.75em',paddingBottom:'0.5em',marginRight:'1em',cursor:'pointer'}} onClick={()=>{setDeletePopup(false)}}>
                                            Cancel
                                        </div>

                                        <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer'}} onClick={()=>{deletesong(deleteTrackIndex);setDeletePopup(false)}}>
                                            Yes, Remove
                                            <div className="PostLoginBtnOverlay"/>
                                        </div>
                                    </div>
        </ReactModal>

        {/* <ReactModal
                            isOpen={unsavedChangesPopup}
                            overlayClassName="Overlay"
                            contentLabel="Example Modal"
                            onRequestClose={closeUnsavedChangesPopup} // closes the modal when the user presses the escape key
                            shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                            style={{
                                content:{
                                width:'32.18em',
                                height:'16.68em',
                                margin:'auto',
                                backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                borderRadius:'8px',
                                border:'0.5px solid rgba(255,255,255,25%)'
                                }
                            }}
                            >
                                
                                <div className="popupheaderinfo">You have unsaved changes</div>
                                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>{setTrackPopup(true);setUnsavedChangesPopup(false)}}/>
                                   

                                

                                    <span className="SettingPopupH3" style={{width:'80%',marginTop:'2em',marginLeft:'-1.6em'}}>Any unsaved progress will be lost if you choose to close. Are you sure you want to close? </span>
                                   
                                   
                                   
                                    <div style={{display:'flex',flexDirection:'row',marginTop:'1em'}}>
                                        <div className="GoBackBtn" style={{paddingTop:'0.55em',paddingBottom:'0.5em',marginRight:'1em',cursor:'pointer'}} onClick={()=>{setTrackPopup(true);setUnsavedChangesPopup(false)}}>
                                            Cancel
                                        </div>

                                        <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer'}} onClick={()=>{setTrackPopup(false);  
                                                                                                                              setUnsavedChangesPopup(false);
                                                                                                                                setTrackname("")
                                                                                                                                setTrackArtists([])
                                                                                                                                setTrackArtist("")
                                                                                                                                setArtistToggle(false)
                                                                                                                                setTrackContributors([])
                                                                                                                                setTrackPublishers([])
                                                                                                                                setLyrics("")
                                                                                                                                setAudioLanguage("")
                                                                                                                                setTrackMetadataLanguage("")
                                                                                                                                setExplicitContent("")
                                                                                                                                setCheckAssetArr(Math.random())}}>
                                            Yes, Close
                                            <div className="PostLoginBtnOverlay"/>
                                        </div>
                                    </div>
        </ReactModal> */}

      {
        pageno=== 0 &&
        <div style={{display:'flex',flexDirection:'column',alignItems:"center"}} ref={ref}>
          <div style={{display:'flex',flexDirection:'column'}}>
            <div className="ReleaseYourMusicHere">Release Your Music Here!</div>   
            <div style={{display:'flex',flexDirection:'column',width:'34.56em',height:'34.37em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)',alignItems:'center',borderRadius:'8px'}}> 
              <img src={ReleaseMusicImg} style={{height:'60.36%',width:'34.56em',borderTopLeftRadius:'8px',borderTopRightRadius:'8px'}}/>
              <div  className="ReleaseYourMusicHereH1">First, let’s set up your artist name so that the world knows who you are.</div>
              <div className="Setupyourartistnamebtn" style={{cursor:'pointer',maxWidth:'20em'}} onClick={()=>navigate("/dashboard/label/settings")}>SET UP YOUR ARTIST NAME</div>
            </div>
          </div>
        </div>
      }

      <Routes>
          {/* <Route exact path="/uploadtracks" element={<Royalties/>}/>  */}
          <Route exact path="/uploadtracks" element={<UploadFiles pagePath={pagePath} setPagePath={setPagePath} setFilesGlobal={setFilesGlobal} filesGlobal={files} trackUploaded={trackUploaded} setTrackUploaded={setTrackUploaded}/>}/>
          <Route exact path="/uploadphoto" element={<AlbumPhoto pagePath={pagePath} setPagePath={setPagePath} albumImage={albumImage} setAlbumImage={setAlbumImage}/>}/>

          <Route exact path="/albumdetails" element={<AlbumDetails albumImage={albumImage} setAlbumImage={setAlbumImage} 
                                                                   pagePath={pagePath} setPagePath={setPagePath}
                                                                   getMonthNo={getMonthNo} getDateNo={getDateNo} 
                                                                   releaseTitle={releaseTitle} setReleaseTitle={setReleaseTitle} 
                                                                   distributeAs={distributeAs} setDistribute={setDistribute} 
                                                                   format={format} setFormat={setFormat} 
                                                                   totalVolumes={totalVolumes} setTotalVolumes={setTotalVolumes}
                                                                   explicitAlbumContent={explicitAlbumContent} setExplicitAlbumContent={setExplicitAlbumContent}
                                                                   consumerReleaseDate={consumerReleaseDate} setConsumerReleaseDate={setConsumerReleaseDate}
                                                                   consumerReleaseTime={consumerReleaseTime} setConsumerReleaseTime={setConsumerReleaseTime}
                                                                   preorderDate={preorderDate} setPreorderDate={setPreorderDate}
                                                                   originalReleaseDate={originalReleaseDate} setOriginalReleaseDate={setOriginalReleaseDate}
                                                                   recordingYear={recordingYear} setRecordingYear={setRecordingYear}
                                                                   recordingLocation={recordingLocation} setRecordingLocation={setRecordingLocation}
                                                                   cCopyrightYear={cCopyrightYear} setCCopyrightYear={setCCopyrightYear}
                                                                   cCopyrightText={cCopyrightText} setCCopyrightTexy={setCCopyrightTexy}
                                                                   pCopyrightYear={pCopyrightYear} setPCopyrightYear={setPCopyrightYear}
                                                                   pCopyrightText={pCopyrightText} setPCopyrightTexy={setPCopyrightTexy}
                                                                   genre={genre} setGenre={setGenre}
                                                                   subgenre={subgenre} setSubGenre={setSubGenre}
                                                                   alternategenre={alternategenre} setAlternateGenre={setAlternateGenre}
                                                                   alternateSubgenre={alternateSubgenre} setAlternateSubGenre={setAlternateSubGenre}
                                                                   albumLanguage={albumLanguage} setAlbumLanguage={setAlbumLanguage}
                                                                   formatcontainerclass={formatcontainerclass} setFormatContainerClass={setFormatContainerClass}
                                                                   defaultdatecontainerclass={defaultdatecontainerclass} setDefaultDateContainerClass={setDefaultDateContainerClass}
                                                                   releasedatecontainerclass={releasedatecontainerclass} setReleaseDateContainerClass={setReleaseDateContainerClass}
                                                                   genrecontainerclass={genrecontainerclass} setGenreContainerClass={setGenreContainerClass}/>}/>
         
            <Route exact path="/trackdetails" element={<TrackDetails pagePath={pagePath} setPagePath={setPagePath} setFiles={setFilesGlobal} files={files}/>}/>

            <Route exact path="/royaltysplit" element={<RoyaltySplit pagePath={pagePath} setPagePath={setPagePath} setFiles={setFilesGlobal} files={files} artistId={artistId} setArtistId={setArtistId}/>}/>

            <Route exact path="/releasedate" element={<ReleaseDate pagePath={pagePath} setPagePath={setPagePath}  getMonthNo={getMonthNo} getDateNo={getDateNo} getMonthTxt={getMonthTxt} releaseDate={releaseDate} setReleaseDate={setReleaseDate} releaseDateError={releaseDateError} setReleaseDateError={setReleaseDateError}/>}/>

            <Route exact path="/albumsummary" element={<AlbumSummary setPageNo={setPageNo}  albumImage={albumImage} setAlbumImage={setAlbumImage} 
                                                                      releaseTitle={releaseTitle} artistName={artistName} genre={genre} 
                                                                      format={format} files={files} releaseDate={releaseDate}
                                                                      pagePath={pagePath} setPagePath={setPagePath}
                                                                      releaseDateError={releaseDateError} createproduct={createproduct} setTimeLeft={setTimeLeft}/>}/>
      
      </Routes>
     

      


      {
        pageno===8 && 
        <div className="LoadingContainer" style={{height:'100%',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:"center"}} ref={ref}>
          <CircularProgress style={{position:'fixed',margin:'auto',width:'5em',height:'5em',marginTop:'35%',marginLeft:'-10em'}} sx={{color:'#FFFFFF'}}/>
        </div>
      }

      

      

      <ReactModal
          isOpen={completionPopup}
          contentLabel="Example Modal"
          overlayClassName="Overlay"
          style={{
            content:{
              width:'35em',
              height:'45.57em',
              margin:'auto',
              backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              borderRadius:'8px',
              border:'0.5px solid rgba(255,255,255,25%)'
            }
          }}
        >
          <img src={crossicon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>{hidedashboard(true);navigate("/dashboard/label")}}/>
          <img src={RequestSubmittedIcon} style={{width:'2.62em',height:'2.62em'}}/>
          <div className='SubmittedHeaderTxt'>{t('Submitted')}</div>
         
         <div style={{position:'relative',marginTop:'2.5em',marginBottom:'2.5em'}}>
         <div style={{background:'rgba(121, 103, 232, 20%)',rotate:'-10deg',width:'13.18em',height:'13.18em',borderRadius:'5px',marginLeft:'-1.2em',marginBottom:'-3em',position:'relative',zIndex:'1'}}>
           
         </div>
         {
                albumImage.length===0 &&
                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dkyvvtdtsyctuil9zpbj"} style={{width:'13.18em',height:'13.18em',rotate:'-10deg',borderRadius:'2px',zIndex:'2',position:'relative',marginTop:'-20em'}}/>
          
              }

              {
                 albumImage.length!==0 &&
                 <img src={URL.createObjectURL(albumImage[0])} style={{width:'13.18em',height:'13.18em',rotate:'-10deg',borderRadius:'2px',zIndex:'2',position:'relative',marginTop:'-20em'}}/>
              }
         
         </div>

          <span className="AlbumSubmittedHeader">{t('Youralbum')} <span className="AlbumTitleTxt">{releaseTitle}</span> {t('Hasbeensubmitted')} </span>

          <ul className="SubmittionPopupPoints">
              <li>Scheduled to release on <span style={{fontWeight:'500',color:'#FFFFFF'}}>{releaseDate}</span></li>
              <li>{t('Onceapproved')}</li>
              <li>{t('Keep100ofroyal')}</li>
        </ul>

        <div className="GotitBtn" onClick={()=>{hidedashboard(true);shareData([]);navigate("/dashboard/label")}}>
          {t('Gotit')}
          <div className="PostLoginBtnOverlay"/>
        </div>
        

        </ReactModal>
       
      </div>
    );
}

export default ReleaseMusic;


function BasicSwitch(props) {
  const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
   
  useEffect(()=>{
    switchChecked=checked
    console.log(switchChecked)
  },[checked])

  const stateClasses = {
    'Switch-checked': checked,
    'Switch-disabled': disabled,
    'Switch-focusVisible': focusVisible,
  };

  return (
    <BasicSwitchRoot className={clsx(stateClasses)}>
      <BasicSwitchThumb className={clsx(stateClasses)} />
      <BasicSwitchInput {...getInputProps()} aria-label="Demo switch" />
    </BasicSwitchRoot>
  );
}



const BasicSwitchRoot = styled('span')(
  ({ theme }) => `
  box-sizing: border-box;
  font-size: 0;
  position: relative;
  display: inline-block;
  width: 38px;
  height: 24px;
  margin: 10px;
  cursor: pointer;
  background: ${theme.palette.mode === 'dark' ? '#1C2025' : '#F3F6F9'};
  
  border-radius: 24px;
  box-shadow: inset 0px 1px 1px ${
    theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0.05)'
  };

  &:hover {
    background: ${theme.palette.mode === 'dark' ? '#303740' : '#E5EAF2'};
  }
    
  &.Switch-focusVisible {
    box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? '#C7A5FF' : '#C7A5FF'};
  }

  &.Switch-disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &.Switch-checked {
   
    background: ${'#C7A5FF'};
    box-shadow: inset 0px 1px 1px ${
      theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.05)'
    };
    &.Switch-focusVisible {
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? '#C7A5FF' : '#C7A5FF'};
    }
  }
  
  `,
);

const BasicSwitchInput = styled('input')`
  box-sizing: border-box;
  cursor: inherit;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 1;
  margin: 0;
`;

const BasicSwitchThumb = styled('span')(
  ({ theme }) => `
  box-sizing: border-box;
  display: block;
  width: 16px;
  height: 16px;
  top: 3px;
  left: 2px;
  border-radius: 16px;
  background-color: #fff;
  
  position: relative;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;
  box-shadow: 0px 1px 2px
    ${theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.1)'};

  &.Switch-checked {
    left: 17px;
    background-color: #fff;
   
  }
`,
);

function PrimarySwitch(props) {
  const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
   
  useEffect(()=>{
    primaryChecked=checked
  },[checked])

  const stateClasses = {
    'Switch-checked': checked,
    'Switch-disabled': disabled,
    'Switch-focusVisible': focusVisible,
  };

  return (
    <TrackSwitchRoot className={clsx(stateClasses)}>
      <TrackSwitchThumb className={clsx(stateClasses)} />
      <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
    </TrackSwitchRoot>
  );
}

function Featured1Switch(props) {
  const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
   
  useEffect(()=>{
    featured1Checked=checked
  },[checked])

  const stateClasses = {
    'Switch-checked': checked,
    'Switch-disabled': disabled,
    'Switch-focusVisible': focusVisible,
  };

  return (
    <TrackSwitchRoot className={clsx(stateClasses)}>
      <TrackSwitchThumb className={clsx(stateClasses)} />
      <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
    </TrackSwitchRoot>
  );
}

function Featured2Switch(props) {
  const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
   
  useEffect(()=>{
    featured2Checked=checked
  },[checked])

  const stateClasses = {
    'Switch-checked': checked,
    'Switch-disabled': disabled,
    'Switch-focusVisible': focusVisible,
  };

  return (
    <TrackSwitchRoot className={clsx(stateClasses)}>
      <TrackSwitchThumb className={clsx(stateClasses)} />
      <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
    </TrackSwitchRoot>
  );
}

function Featured3Switch(props) {
  const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
   
  useEffect(()=>{
    featured3Checked=checked
  },[checked])

  const stateClasses = {
    'Switch-checked': checked,
    'Switch-disabled': disabled,
    'Switch-focusVisible': focusVisible,
  };

  return (
    <TrackSwitchRoot className={clsx(stateClasses)}>
      <TrackSwitchThumb className={clsx(stateClasses)} />
      <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
    </TrackSwitchRoot>
  );
}


function Featured4Switch(props) {
  const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
   
  useEffect(()=>{
    featured4Checked=checked
  },[checked])

  const stateClasses = {
    'Switch-checked': checked,
    'Switch-disabled': disabled,
    'Switch-focusVisible': focusVisible,
  };

  return (
    <TrackSwitchRoot className={clsx(stateClasses)}>
      <TrackSwitchThumb className={clsx(stateClasses)} />
      <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
    </TrackSwitchRoot>
  );
}


function Featured5Switch(props) {
  const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
   
  useEffect(()=>{
    featured5Checked=checked
  },[checked])

  const stateClasses = {
    'Switch-checked': checked,
    'Switch-disabled': disabled,
    'Switch-focusVisible': focusVisible,
  };

  return (
    <TrackSwitchRoot className={clsx(stateClasses)}>
      <TrackSwitchThumb className={clsx(stateClasses)} />
      <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
    </TrackSwitchRoot>
  );
}


function Featured6Switch(props) {
  const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
   
  useEffect(()=>{
     featured6Checked=checked
  },[checked])

  const stateClasses = {
    'Switch-checked': checked,
    'Switch-disabled': disabled,
    'Switch-focusVisible': focusVisible,
  };

  return (
    <TrackSwitchRoot className={clsx(stateClasses)}>
      <TrackSwitchThumb className={clsx(stateClasses)} />
      <TrackSwitchInput {...getInputProps()} aria-label="Demo switch" />
    </TrackSwitchRoot>
  );
}




const TrackSwitchRoot = styled('span')(
  ({ theme }) => `
  box-sizing: border-box;
  font-size: 0;
  position: relative;
  display: inline-block;
  width: 38px;
  height: 22px;
  margin: 10px;
  cursor: pointer;
  background: ${theme.palette.mode === 'dark' ? '#E91353' : 'rgba(255, 255, 255, 60%)'};
  
  border-radius: 24px;
  box-shadow: inset 0px 1px 1px ${
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 60%)' : 'rgba(0, 0, 0, 0.05)'
  };

  &:hover {
    background: ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 60%)' : 'rgba(255, 255, 255, 60%)'};
  }
    
  &.Switch-focusVisible {
    box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 60%)' : 'rgba(255, 255, 255, 60%)'};
  }

  &.Switch-disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &.Switch-checked {
   
    background: ${'#E91353'};
    box-shadow: inset 0px 1px 1px ${
      theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.05)'
    };
    &.Switch-focusVisible {
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 60%)' : 'rgba(255, 255, 255, 60%)'};
    }
  }
  
  `,
);

const TrackSwitchInput = styled('input')`
  box-sizing: border-box;
  cursor: inherit;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 1;
  margin: 0;
`;

const TrackSwitchThumb = styled('span')(
  ({ theme }) => `
  box-sizing: border-box;
  display: block;
  width: 16px;
  height: 16px;
  top: 3px;
  left: 2px;
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 60%);
  
  position: relative;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;
  box-shadow: 0px 1px 2px
    ${theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.1)'};

  &.Switch-checked {
    left: 17px;
    background-color: #fff;
   
  }
`,
);